import { ArrowUpward, Close, Folder } from '@mui/icons-material'
import {
  StyledButtonBackToTop,
  StyledDrawerContent,
  StyledDrawerTitle,
  StyledGrid,
  StyledGroupItem,
  StyledListItem,
  StyledProductsDrawer,
  StyledNavbarContainer,
  StyledNavbarTitle
} from './styles'
import {
  IconGroupAnaliseCadastral,
  IconGroupAnaliseRisco,
  IconGroupInfobusca,
  IconGroupServicosCartoriais,
  IconGroupSitiacaoVeicular,
  IconGroupVerificacaoCredito,
  IconCpfCnpjLight,
  IconCpfCnpjPeloEmail,
  IconCpfCnpjPeloNome,
  IconCpfCnpjCompleto,
  IconDddTelefone,
  IconGeolocalizacao,
  IconGeomarketing,
  IconLinhaDoTempo,
  IconListaTelefonica,
  IconMatrizFilial,
  IconNumeroBeneficio,
  IconOutrosDocumentos,
  IconPerfilCnpj,
  IconPerfilSocioEconomico,
  IconPessoaExpostaPoliticamente,
  IconRendaFaturamentoMensal,
  IconSimplesNacional,
  IconSintegra,
  IconSituacaoReceita,
  IconSituacaoReceitaCompleto,
  IconAdvancedBackgroundCheckABC,
  IconAlertaMonitore,
  IconBolsaFamilia,
  IconBuscaJudicial,
  IconCertidaoAntecedentesCriminaisCpfPoliciaFederal,
  IconClassificacaoBrasileiraOcupacaoCBO,
  IconDataMatch,
  IconDataValidBiometricaSimples,
  IconDataValidCadastralSimples,
  IconFaceCompare,
  IconFaturamentoGrupo,
  IconHistoricoAcademicoEscolar,
  IconIndicadorAtividade,
  IconLiveness,
  IconMercadoFinanceiro,
  IconMidiasNegativas,
  IconOcr,
  IconQuadroSocietarioAvancado,
  IconQuantidadeParticipacao,
  IconRestituicaoIRPF,
  IconServidorPublico,
  IconInfobusca,
  IconAcompanhamento,
  IconBuscaBens,
  IconCertidaoNegativaImoveis,
  IconMatriculaAtualizada,
  IconVeiculos,
  IconChequePlus,
  IconConcentre,
  IconCreditoBureau,
  IconCrednet,
  IconNegativacao,
  IconRecomenda,
  IconRelato,
  IconRelatorioBasico,
  IconRelatorioAvancado
} from '../../assets/img/svg/logoFeatures'
import stores from '../../stores/store'
import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

const iconMapping: { [key: string]: JSX.Element } = {
  'Análise Cadastral': <IconGroupAnaliseCadastral />,
  'Registration Analysis': <IconGroupAnaliseCadastral />,
  'Análise de Risco': <IconGroupAnaliseRisco />,
  'Risk Analysis': <IconGroupAnaliseRisco />,
  Infobusca: <IconGroupInfobusca />,
  Infosearch: <IconGroupInfobusca />,
  'Serviços cartoriais': <IconGroupServicosCartoriais />,
  'Notary Services': <IconGroupServicosCartoriais />,
  'Situação Veicular': <IconGroupSitiacaoVeicular />,
  'Vehicle Status': <IconGroupSitiacaoVeicular />,
  'Verificação de Crédito': <IconGroupVerificacaoCredito />,
  'Credit Check': <IconGroupVerificacaoCredito />
}

const iconMappingItems: { [key: string]: JSX.Element } = {
  'Cpf/Cnpj light': <IconCpfCnpjLight />,
  'Light Cpf/Cnpj': <IconCpfCnpjLight />,

  'Cpf/Cnpj pelo e-mail': <IconCpfCnpjPeloEmail />,
  'Cpf/Cnpj by E-mail': <IconCpfCnpjPeloEmail />,

  'Cpf/Cnpj pelo nome': <IconCpfCnpjPeloNome />,
  'Cpf/Cnpj by Name': <IconCpfCnpjPeloNome />,

  'CpfCnpj completo': <IconCpfCnpjCompleto />,
  'Full Cpf/Cnpj': <IconCpfCnpjCompleto />,

  'DDD + telefone': <IconDddTelefone />,
  'Area Code + Phone Number': <IconDddTelefone />,

  Geolocalização: <IconGeolocalizacao />,
  'Address by coordinates': <IconGeolocalizacao />,

  Geomarketing: <IconGeomarketing />,

  'Linha do tempo': <IconLinhaDoTempo />,
  Timeline: <IconLinhaDoTempo />,

  'Lista telefônica': <IconListaTelefonica />,

  'Matriz / filial': <IconMatrizFilial />,
  'Headquarters or Branch': <IconMatrizFilial />,

  'Número do benefício': <IconNumeroBeneficio />,
  'Benefit Number': <IconNumeroBeneficio />,

  'Outros documentos': <IconOutrosDocumentos />,
  'Other Documents': <IconOutrosDocumentos />,

  'Perfil cnpj': <IconPerfilCnpj />,
  'Cnpj Profile': <IconPerfilCnpj />,

  'Perfil sócio econômico': <IconPerfilSocioEconomico />,
  'Socio-economic Profile': <IconPerfilSocioEconomico />,

  'Pessoa exposta politicamente': <IconPessoaExpostaPoliticamente />,
  'Politically exposed person': <IconPessoaExpostaPoliticamente />,

  'Quadro societário / Participação em empresa(s)': (
    <IconQuadroSocietarioAvancado />
  ),
  'Corporate Membership / Stake in Company(ies)': (
    <IconQuadroSocietarioAvancado />
  ),

  'Renda / faturamento mensal': <IconRendaFaturamentoMensal />,
  'Monthly Income / Invoicing': <IconRendaFaturamentoMensal />,

  'Simples nacional': <IconSimplesNacional />,
  'Simple National': <IconSimplesNacional />,

  Sintegra: <IconSintegra />,

  'Situação receita': <IconSituacaoReceita />,
  'Revenue Situation': <IconSituacaoReceita />,

  'Situação Receita Completo': <IconSituacaoReceitaCompleto />,
  'Complete Revenue Status': <IconSituacaoReceitaCompleto />,

  'Advanced background check (ABC)': <IconAdvancedBackgroundCheckABC />,
  'Advanced Background Check (ABC)': <IconAdvancedBackgroundCheckABC />,

  'Alerta monitore': <IconAlertaMonitore />,
  'Monitor Alert': <IconAlertaMonitore />,

  'Bolsa Família': <IconBolsaFamilia />,
  'Family Allowance': <IconBolsaFamilia />,

  'Busca judicial': <IconBuscaJudicial />,

  'Certidão antecedentes criminais Cpf - Polícia Federal': (
    <IconCertidaoAntecedentesCriminaisCpfPoliciaFederal />
  ),
  'Federal Police Criminal Record Certificate for Individuals': (
    <IconCertidaoAntecedentesCriminaisCpfPoliciaFederal />
  ),

  'Classificação Brasileira de Ocupação (CBO)': (
    <IconClassificacaoBrasileiraOcupacaoCBO />
  ),
  'Brazilian Classification of Occupations (CBO)': (
    <IconClassificacaoBrasileiraOcupacaoCBO />
  ),

  'Data match': <IconDataMatch />,
  'Data Match': <IconDataMatch />,

  'Data Valid - Biometrica Simples': <IconDataValidBiometricaSimples />,
  'Data Valid - Simple Biometric': <IconDataValidBiometricaSimples />,

  'Data Valid - Cadastral Simples': <IconDataValidCadastralSimples />,
  'Data Valid - Simple Registration': <IconDataValidCadastralSimples />,

  'Face compare': <IconFaceCompare />,

  'Faturamento Grupo': <IconFaturamentoGrupo />,
  'Group Billing': <IconFaturamentoGrupo />,

  'Histórico Acadêmico e Escolar': <IconHistoricoAcademicoEscolar />,
  'Academic Transcript': <IconHistoricoAcademicoEscolar />,

  'Indicador de atividade': <IconIndicadorAtividade />,
  'Activity indicator': <IconIndicadorAtividade />,

  Liveness: <IconLiveness />,

  'Mercado financeiro': <IconMercadoFinanceiro />,
  'Financial market': <IconMercadoFinanceiro />,

  'Midias negativas': <IconMidiasNegativas />,
  'Negative Media': <IconMidiasNegativas />,

  Ocr: <IconOcr />,

  'Quadro societário avançado': <IconQuadroSocietarioAvancado />,
  'Advanced Corporate Governance': <IconQuadroSocietarioAvancado />,

  'Quantidade de Participação': <IconQuantidadeParticipacao />,
  'Participation Quantity': <IconQuantidadeParticipacao />,

  'Restituição IRPF': <IconRestituicaoIRPF />,
  'Restitution IRPF': <IconRestituicaoIRPF />,

  'Servidor público': <IconServidorPublico />,
  'Public Servant': <IconServidorPublico />,

  Infobusca: <IconInfobusca />,
  InfoSeek: <IconInfobusca />,

  Acompanhamento: <IconAcompanhamento />,
  Tracking: <IconAcompanhamento />,

  'Busca bens': <IconBuscaBens />,
  'Search for assets': <IconBuscaBens />,

  'Certidão negativa imóveis': <IconCertidaoNegativaImoveis />,
  'Negative certificate of property': <IconCertidaoNegativaImoveis />,

  'Matrícula atualizada': <IconMatriculaAtualizada />,
  'Updated registration': <IconMatriculaAtualizada />,

  Veículos: <IconVeiculos />,
  Vehicles: <IconVeiculos />,

  'Cheque plus': <IconChequePlus />,
  'Check Plus': <IconChequePlus />,

  Concentre: <IconConcentre />,

  'Crédito Bureau': <IconCreditoBureau />,
  'Credit Bureau': <IconCreditoBureau />,

  Crednet: <IconCrednet />,

  Negativação: <IconNegativacao />,
  Negativation: <IconNegativacao />,

  Recomenda: <IconRecomenda />,
  Recommends: <IconRecomenda />,

  Relato: <IconRelato />,

  'Relatório Básico': <IconRelatorioBasico />,
  'Basic Report': <IconRelatorioBasico />,

  'Relatório Avançado': <IconRelatorioAvancado />,
  'Advanced Report': <IconRelatorioAvancado />
}

export default function Navbar() {
  const { setLeftMenuItemSelected } = stores.DataLeftMenuSelected()
  const { listSidebar } = stores.DataSidebarStore()
  const { jsonSelected: lang } = stores.DataLocaleStore()
  const location = useLocation()
  const navigate = useNavigate()

  const queryParams = new URLSearchParams(location.search).toString()

  const [openDrawerCategory, setOpenDrawerCategory] = useState<string | null>(
    null
  )
  const [showBackToTop, setShowBackToTop] = useState(false)

  useEffect(() => {
    const scrollContainer = document.getElementsByTagName('body')[0]

    const handleScroll = () => {
      if (scrollContainer.scrollTop > 100) {
        setShowBackToTop(true)
      } else {
        setShowBackToTop(false)
      }
    }
    scrollContainer.addEventListener('scroll', handleScroll)
    return () => scrollContainer.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const itemSelected = listSidebar
      .flatMap((group) => group.list)
      .find((item) => item.path === location.pathname)

    if (itemSelected) {
      setLeftMenuItemSelected(itemSelected.name)
    }
  }, [listSidebar, location.pathname])

  return (
    <>
      <StyledNavbarTitle>{lang.navbar.products}</StyledNavbarTitle>
      <StyledNavbarContainer>
        {listSidebar.map((category) => (
          <StyledGrid
            key={category.name}
            onClick={() => setOpenDrawerCategory(category.name)}
          >
            {iconMapping[category.name] || <Folder />}
            <span>{category.name}</span>
          </StyledGrid>
        ))}
      </StyledNavbarContainer>

      {listSidebar.map((category) => (
        <StyledProductsDrawer
          key={category.name}
          anchor="top"
          open={openDrawerCategory === category.name}
          onClose={() => setOpenDrawerCategory(null)}
        >
          <StyledDrawerTitle>
            <span>{category.name}</span>
            <Close
              onClick={() => setOpenDrawerCategory(null)}
              style={{ cursor: 'pointer' }}
            />
          </StyledDrawerTitle>

          <StyledDrawerContent>
            <StyledGroupItem>
              {category.list.map((item) => (
                <StyledListItem
                  key={item.href}
                  to={`${item.path}${queryParams ? `?${queryParams}` : ''}`}
                  onClick={() => {
                    setLeftMenuItemSelected(item.name)
                    setOpenDrawerCategory(null)
                  }}
                >
                  {iconMappingItems[item.name] || <Folder />}
                  <span>{item.name}</span>
                </StyledListItem>
              ))}
            </StyledGroupItem>
          </StyledDrawerContent>
        </StyledProductsDrawer>
      ))}

      {showBackToTop && (
        <StyledButtonBackToTop
          onClick={() => {
            const container = document.getElementsByTagName('body')[0]
            if (container) {
              container.scrollTo({ top: 0, behavior: 'smooth' })
            }
          }}
        >
          <ArrowUpward />
        </StyledButtonBackToTop>
      )}
    </>
  )
}
